export enum TransactionStatus {
    FAILED = 'failed',
    PENDING = 'pending',
    SUCCESS = 'success',
    PAID = 'paid',
    COMPLETED = 'completed',
    REFUNDED = 'refunded',
    CANCELLED = 'cancelled',
    UNPAID = 'unpaid',
    REFUNDED_PENDING = 'refund pending',
    TRANSACTION_IN_PROGRESS = 'transaction in progress',
    ALERT = 'alert',
}

export enum TransactionTokenType {
    NONE,
    SINGLE,
    MULTIPLE,
}

export enum PaySmallSmallCheckoutType {
    PayTotalOutstanding = 'PayTotalOutstanding',
    PayDueNow = 'PayDueNow',
    PayAllDue = 'PayAllDue',
    PayOnlyDefaulted = 'PayOnlyDefaulted',
}

export enum PaymentProvider {
    FINERACT = 'fineract',
    POWERAPP_BALANCE = 'powerapp balance',
    OLTPV = 'oltpv',
    CARD = 'card',
    GHANA_GOV = 'ghana.gov',
    GMONEY = 'g-money',
}

export enum TransactionType {
    meter = 'meter',
    customerStatement = 'customer statement',
    creditTransfer = 'credit transfer',
    invoice = 'invoice',
    debtPayment = 'debt payment',
    dueDebtPayment = 'due debt payment',
}
